import React from 'react';
import PropTypes from 'prop-types';
import {CustomerType, UserType} from '../../propTypes';
import {entity as emailSnippets} from '../../ducks/emailSnippets';
import {customers, tags, users} from '../../ducks/index';
import SnippetList from './SnippetList';
import EmailSnippetEditor from './EmailSnippetEditor';
import {duckify, singleDuck, filterDuck} from '../../utils/duckify';
import FA from '../../utils/FA';
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import {compose} from "redux";
import {withRouter} from "react-router";
import withFiltering from "../../hocs/withFiltering";
import withSorting from '../../hocs/withSorting'
import {withSnippetFunctions} from "./snippetUtils";
import withTagging from "../../hocs/withTagging";


const EmailSnippetList = (props) => {

    const {
      items:unfilteredItems,
      filterType,
      customer,
      currentUser,
      tags,
      onSort,
      sort,
      ...extraProps
    } = props;

    const items = unfilteredItems.filter(snippet => snippet.include_in_list && filterType.includes(snippet.type));

    const links = [
      ['Custom Emails', '/setup/email_snippets'],
      ['Authentication Emails', '/setup/auth_snippets'],
      ['Request Emails', '/setup/recommendation_snippets'],
      ['System Emails', '/setup/system_snippets']
    ];

    // permission check to see if we show billing emails
    if (Object.keys(customer).length !== 0 && customer.modules.includes('billing')) {
      links.push(['Billing Emails', '/setup/billing_snippets']);
    }

    // passing this as an empty array overrides the call that populates this const with the "create email" button
    const collectionButtons = filterType.includes('EmailSnippet') ? undefined : [];
    // tags are only supported for custom emails, passing undefined disables them
    const snippetTags = filterType.includes('EmailSnippet') ? tags : undefined;

    return (
      <SnippetList
        items={items}
        displayName='Email'
        editModal={EmailSnippetEditor}
        tags={snippetTags}
        type='email'
        links={links}
        collectionButtons={collectionButtons}
        onSort={onSort}
        sort={sort}
        {...extraProps}
      >
        {currentUser.financial_permitted && currentUser.acl >= 2 && filterType.includes('BillingEmailSnippet') && (
          <p>
            <em>
              <FA icon={faInfoCircle} postNbsp />
              Visit
              {' '}
              <a href={'/setup/billing_config'}>Billing Setup</a>
              {' '}
              to manage the frequency of some Billing Emails, e.g. Upcoming Statement and Account Overdue.
            </em>
          </p>
        )}
      </SnippetList>
    );
}

EmailSnippetList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  filterType: PropTypes.arrayOf(PropTypes.string).isRequired,
  customer: CustomerType.isRequired,
  currentUser: UserType.isRequired,
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapDucksToProps = ({filters, sortJson}) => {
  return {
    customer: singleDuck(customers, 'current'),
    currentUser: singleDuck(users, 'current'),
    items: filterDuck(emailSnippets, {
      filters,
      sort: sortJson,
    }),
    tags
  };
}

export default compose(
  withRouter,
  withFiltering,
  withTagging(emailSnippets),
  withSnippetFunctions(emailSnippets),
  withSorting({
    column: 'name',
    order: 'asc'
  }),
  duckify(mapDucksToProps)
)(EmailSnippetList);
